import React from "react";
import { Badge } from "/src/modern/components/ui/badge";
import { Button } from "/src/modern/components/ui/button";

const filterConfig = {
  boardTypes: {
    created: { label: "Boards I Created", icon: "fa fa-crown", color: "bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-400" },
    invited: { label: "Boards I'm Invited To", icon: "fa fa-user-plus", color: "bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-400" },
    template: { label: "Templates", icon: "fa fa-magic", color: "bg-purple-100 text-purple-800 dark:bg-purple-900/20 dark:text-purple-400" }
  },
  roles: {
    Administrator: { label: "Administrator", color: "bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-400" },
    Executive: { label: "Executive", color: "bg-orange-100 text-orange-800 dark:bg-orange-900/20 dark:text-orange-400" },
    Scheduler: { label: "Scheduler", color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-400" },
    Office: { label: "Office", color: "bg-indigo-100 text-indigo-800 dark:bg-indigo-900/20 dark:text-indigo-400" },
    Workforce: { label: "Workforce", color: "bg-teal-100 text-teal-800 dark:bg-teal-900/20 dark:text-teal-400" }
  },
  workforceStatus: {
    active: { label: "Active Workforce", color: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/20 dark:text-emerald-400" },
    inactive: { label: "Inactive Workforce", color: "bg-gray-100 text-gray-800 dark:bg-gray-900/20 dark:text-gray-400" }
  },
};

export function FilterPills({ filters, onFiltersChange, searchQuery, onSearchChange }) {
  const handleRemoveFilter = (filterType, value) => {
    const newFilters = { ...filters };
    newFilters[filterType] = newFilters[filterType].filter((item) => item !== value);
    onFiltersChange(newFilters);
  };

  const handleClearAll = () => {
    onFiltersChange({
      boardTypes: [],
      roles: [],
      workforceStatus: [],
      categories: [],
    });
    if (onSearchChange) {
      onSearchChange("");
    }
  };

  // Get all active filters
  const activeFilters = [];
  Object.entries(filters).forEach(([filterType, values]) => {
    values.forEach((value) => {
      const config = filterConfig[filterType]?.[value];
      if (config) {
        activeFilters.push({
          type: filterType,
          value,
          label: config.label,
          icon: config.icon,
          color: config.color
        });
      }
    });
  });

  // Add search query as a pill if it exists
  const hasActiveSearch = searchQuery && searchQuery.trim() !== "";
  const hasActiveFilters = activeFilters.length > 0;
  if (!hasActiveSearch && !hasActiveFilters) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2 items-center">
      <span className="text-sm font-medium text-gray-700 dark:text-gray-300 mr-2">
        Active filters:
      </span>

      {/* Search Query Pill */}
      {hasActiveSearch && (
        <Badge
          variant="secondary"
          className="bg-amber-100 text-amber-800 dark:bg-amber-900/20 dark:text-amber-400 border-0 px-3 py-1 text-xs font-medium flex items-center gap-1.5"
        >
          <i className="fa fa-search text-xs" />
          Search: "{searchQuery.trim()}"
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onSearchChange("")}
            className="h-4 w-4 p-0 ml-1 hover:bg-transparent hover:opacity-70"
          >
            <i className="fa-regular fa-xmark"></i>
          </Button>
        </Badge>
      )}

      {/* Filter Pills */}
      {activeFilters.map((filter, index) => (
        <Badge
          key={`${filter.type}-${filter.value}-${index}`}
          variant="secondary"
          className={`${filter.color} border-0 px-3 py-1 text-xs font-medium flex items-center gap-1.5`}
        >
          {filter.icon && <i className={`${filter.icon} text-xs`} />}
          {filter.label}
          <Button
            variant="ghost"
            size="sm"
            onClick={() => handleRemoveFilter(filter.type, filter.value)}
            className="h-4 w-4 p-0 ml-1 hover:bg-transparent hover:opacity-70"
          >
            <i className="fa-regular fa-xmark"></i>
          </Button>
        </Badge>
      ))}

      <Button
        variant="ghost"
        size="sm"
        onClick={handleClearAll}
        className="h-6 px-2 text-xs text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200"
      >
        Clear all
      </Button>
    </div>
  );
}